import React from "react";
import { Button } from "@mui/material";
import { format } from "date-fns";
import { UseFormReturn } from "react-hook-form";
import IIndicationsRequest from "../panels/addFOBIndicationPanel/types/IIndicationsRequest";

interface CopyToClipboardButtonProps {
  form: UseFormReturn<IIndicationsRequest>;
  index: number;
  buttonText?: string;
  variant?: "text" | "outlined" | "contained";
}

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  form,
  index,
  buttonText = "Copy to clipboard",
  variant = "contained"
}) => {
  const handleCopyToClipboard = async () => {
    const record = form.getValues();
    const indication = record.indications[index];

    let message = "";

    message += `Product= ${indication.product}\n`;
    
    // Handle prices based on indication structure
    indication.prices.forEach((r) => {
      if (indication.priceType === "single") {
        message += `Origin= ${r.origin} | Price= $${r.fobPrice}\n`;
      } else {
        message += `Origin= ${r.origin} | Price= $${r.fobMinPrice} - $${r.fobMaxPrice}\n`;
      }
    });
    
    if (indication.quantity) {
      message += `Qty= ${indication.quantity}\n`;
    }
    message += `Contact= ${record.contactName}\n`;
    message += `Account= ${record.party}\n`;
    message += `Ship Window= ${format(
      new Date(
        (indication.startDate as string).replaceAll("-", "/")
      ),
      "MMM yyyy"
    )} - ${format(
      new Date(
        (indication.endDate as string).replaceAll("-", "/")
      ),
      "MMM yyyy"
    )}\n`;
    message += `Mode= ${indication.mode}\n`;
    message += indication.comments;

    await navigator.clipboard.writeText(message);
  };

  return (
    <Button
      variant={variant}
      onClick={handleCopyToClipboard}
    >
      {buttonText}
    </Button>
  );
};

export default CopyToClipboardButton;